import React from "react";
import style from "./Chatcard.module.css";
import { BsCheckLg } from "react-icons/bs";
const Chatcard = (props) => {
  return (
    <div
      className={style.infocard}
      onClick={props.addtochat && props.addtochat.bind(this, props.client)}>
      <div className={style.img}>
        <img src={props.client.photoURL} />
        {props.userarray.some((item) => item.user_id === props.client.uid) && (
          <div>
            <BsCheckLg size={30} />
          </div>
        )}
      </div>
      <div className={style.text}>
        <p>{props.client.displayname}</p>
      </div>
    </div>
  );
};
export default Chatcard;
